import { Team } from "../logic/team";
import { Storage } from "./storage";

export { Team };

export const teamStorage = new Storage<Team>('/api/teams', 'team', defaultTeam(), false);

export function defaultTeam() {
  return Team.default();
}